import React from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import "./quote.m.css";

export const QuoteElement = ({ element }) => {
  const quoteElement = get(element, ["metadata", "content"], "");
  const quoteAttribution = get(element, ["metadata", "attribution"], "");
  return (
    <div styleName="quote-wrapper">
      <q styleName="text" dangerouslySetInnerHTML={{ __html: quoteElement }} />
      <p styleName="attribution">{quoteAttribution}</p>
    </div>
  );
};
QuoteElement.propTypes = {
  element: PropTypes.shape({
    quoteElement: PropTypes.string,
    quoteAttribution: PropTypes.string
  })
};